module.exports = __webpack_public_path__ + "img/vegetable-snow-peas-350x184.b5c6e865.jpg";